import sitesService from "@/services/sites";
import router from "../../router/index";

const getDefaultState = () => {
  return {
    loading: false,
    long: null,
    lat: null,
    radius: null,
    locationName: "",
    zoom: "",
    hideSiteModal: false,
    sitesList: [],
    sitesWithAreas: [],
    sitesWithAreasAndKiosks: [],
    actionState: false,
    siteAreas: [],
    areaCompliances: [],
    areaDocuments: [],
    areasFilter: [],
    isSignInOutMode: false,
    hasVisit: false,
    checkInMsg: "",
    stausForAre: null,
    stausesForArea: null,
    isLoader: false,
    countUsersSingnedIn: null,
    userHasVisitTodayOnOneOfSites: null,
    signedInUserVisitDetails: null,
  };
};

export const state = getDefaultState();

export const actions = {
  // fetch sites
  fetchSites({ commit, dispatch }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .getSites()
        .then((data) => {
          resolve(data);
          commit("setSites", data.data);
          commit("setCompliances", []);
          commit("setAreas", []);
          commit("modal/setModalState", false, { root: true });
          dispatch("grid/resetSelectedRows", null, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },

  fetchNormalSites({ commit, dispatch }) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .getNormalSites()
        .then((data) => {
          resolve(data);
          commit("setSites", data.data);
          commit("setCompliances", []);
          commit("setAreas", []);
          commit("modal/setModalState", false, { root: true });
          dispatch("grid/resetSelectedRows", null, { root: true });
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
        });
    });
  },
  fetchAllSites() {
    return new Promise((resolve, reject) => {
      sitesService
        .getSites()
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // fetch sites with areas
  fetchSiteswithAreas({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      sitesService
        .getSitesWithAreas()
        .then((data) => {
          resolve(data);
          commit("setSitesWithAreas", data.data);
          commit("modal/setModalState", false, { root: true });
          commit("setAreas", []);
          dispatch("grid/resetSelectedRows", null, { root: true });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**************** START::Actions for new Sites&Kiosks treelist ******************/
  // fetch sites only
  fetchEntitySites({ commit }) {
    return new Promise((resolve, reject) => {
      sitesService
        .getSites()
        .then((data) => {
          resolve(data);
          commit("setSites", data.data);
          // commit("setSitesWithAreas", data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setLocationName({ commit }, payload) {
    commit("setLocationName", payload);
  },
  setZoom({ commit }, payload) {
    commit("setZoom", payload);
  },
  //For new treelist
  createNewSite({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .createSite(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Site Added");
          commit("setLoading", false);
          dispatch("fetchSitesWithAreasAndKiosks");
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          this._vm.$toast.error(Object.values(err.data.errors).join("\r\n"));
          commit("modal/setModalState", false, { root: true });
        });
    });
  },
  clearSitesWithAreasAndKiosksTreeList({ commit }) {
    commit("clearSitesWithAreasAndKiosksTreeList");
  },
  fetchAllAreasInEntity({ commit }) {
    return new Promise((resolve, reject) => {
      sitesService
        .getAllAreasInEntity()
        .then((data) => {
          resolve(data);
          let allAreas = data.data;
          let areas = [];

          //Traverse all areas + flatten array
          let traverse = (node) => {
            if (node.items) {
              node.items.forEach((area) => {
                traverse(area);
              });
            }
            if (!node.site) {
              areas.push(
                Object.assign(node, { id: node.value, name: node.text })
              );
            }
          };
          for (let indx in allAreas) {
            traverse(Object.assign(allAreas[indx], { site: true }));
          }

          commit("setAreas", areas);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  /**************** END::Actions for new Sites&Kiosks treelist *****************/
  // create site
  createSite({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .createSite(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Site Added");
          commit("setLoading", false);
          dispatch("fetchSiteswithAreas");
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          this._vm.$toast.error(Object.values(err.data.errors).join("\r\n"));
          commit("modal/setModalState", false, { root: true });
        });
    });
  },
  // update site
  updateSite({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .updateSite(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Site Updated");
          commit("setLoading", false);
          dispatch("fetchSiteswithAreas");
          dispatch("fetchSitesWithAreasAndKiosks");
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // delete site
  deleteSite({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      sitesService
        .deleteSite(id)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
          dispatch("fetchSiteswithAreas");
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // create area
  createArea({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .createArea(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Area Added");
          commit("setLoading", false);
          dispatch("fetchAreasFilter", {
            id: router.history.current.params.id,
          });
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // update area
  updateArea({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .updateArea(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Area Updated");
          commit("setLoading", false);
          dispatch("fetchAreasFilter", {
            id: router.history.current.params.id,
          });
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          commit("modal/setModalState", false, { root: true });
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  capitalize(s) {
    (s && s[0].toUpperCase() + s.slice(1)) || "";
  },
  // move area
  moveArea({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .moveArea(params)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Area Moved");
          commit("setLoading", false);
          dispatch("fetchAreasFilter", {
            id: router.history.current.params.id,
          });
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.data.message && err.data.message.length == 0
            ? this._vm.$toast.error(err.data.message)
            : this._vm.$toast.error(
                err.data.data.charAt(0).toUpperCase() + err.data.data.slice(1)
              );
          commit("modal/setModalState", false, { root: true });
        });
    });
  },
// download area exe file
downloadAreaExeFile({ commit }, id) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .downloadAreaExeFile(id)
        .then((data) => {
          resolve(data);
          // this._vm.$toast.success(data.message);
          commit("setLoading", false);
          commit("modal/setModalState", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.data.message && err.data.message.length == 0
            ? this._vm.$toast.error(err.data.message)
            : this._vm.$toast.error(
                err.data.data.charAt(0).toUpperCase() + err.data.data.slice(1)
              );
          commit("modal/setModalState", false, { root: true });
        });
    });
  },
  // delete area
  deleteArea({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      sitesService
        .deleteArea(id)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success("Area Deleted");
          dispatch("fetchAreasFilter", {
            id: router.history.current.params.id,
          });
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // areas by site {{that has kiosks}}
  fetchAreasHaskiosks({ commit }, id) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .getAreasHaskiosk(id)
        .then((data) => {
          resolve(data);
          commit("setAreas", data.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAreasFilter({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      sitesService
        .getAreasFilter(id)
        .then((data) => {
          resolve(data);
          commit("setAreasFilter", data.data);
          commit("modal/setModalState", false, { root: true });
          commit("setAreas", []);
          dispatch("grid/resetSelectedRows", null, { root: true });
          // dispatch("checkAreasMode", id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkAreasMode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      sitesService
        .checkAreasMode(payload)
        .then((data) => {
          resolve(data);
          commit("setAreasMode", data.data);
        })
        .catch((err) => {
          reject(err);
          // err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // areas by site
  fetchAreasBySite({ commit }, id) {
    return new Promise((resolve, reject) => {
      sitesService
        .getAreasBysites(
          id.is_remote ? { site_id: id.site_id, is_remote: true } : id
        )
        .then((data) => {
          resolve(data);
          commit("setAreas", data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  // compliance or area
  fetchAreaCompliances({ commit }, params) {
    return new Promise((resolve, reject) => {
      sitesService
        .getSpecficCompliances(params)
        .then((data) => {
          resolve(data);
          commit("setCompliances", data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAreaDocument({ commit }, params) {
    return new Promise((resolve, reject) => {
      sitesService
        .getAreaDocument(params)
        .then((data) => {
          resolve(data);
          // console.log('setDocuments', data.data);
          commit("setDocuments", data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchStatusForArea({ commit }, params) {
    commit("setLoader", true);
    return new Promise((resolve, reject) => {
      sitesService
        .getStatusForArea(params)
        .then((data) => {
          resolve(data);
          commit("setStausForAre", data.data);
          commit("setLoader", false);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAllStatusesForArea({ commit }, params) {
    commit("setLoader", true);
    return new Promise((resolve, reject) => {
      sitesService
        .getAllStatusForArea(params)
        .then((data) => {
          resolve(data);
          commit("setAllStausesForArea", data.data);
          commit("setLoader", false);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  updateActionState({ commit }, payload) {
    commit("actionState", payload);
  },

  checkSignInOutMode({ commit }, payload) {
    commit("setIsSignInOutMode", false);
    return new Promise((resolve, reject) => {
      sitesService
        .checkSignInOutMode(payload)
        .then((data) => {
          resolve(data);
          commit("setIsSignInOutMode", data.data == true);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },

  fetchAreasBySiteWithoutSignOut({ commit }, payload) {
    return new Promise((resolve, reject) => {
      sitesService
        .fetchAreasBySiteWithoutSignOut(payload)
        .then((data) => {
          resolve(data);
          commit("setAreas", data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchCountUsersSingnedIn({ commit }, payload) {
    return new Promise((resolve, reject) => {
      sitesService
        .getCountUsersSingnedInApi(payload)
        .then((data) => {
          resolve(data);
          commit("setCountUsersSingnedIn", data.data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },

  checkUserHasVisitInArea({ commit }, payload) {
    commit("setHasVisit", false);
    commit("setCheckInMsg", "");
    return new Promise((resolve, reject) => {
      sitesService
        .checkUserHasVisitInArea(payload)
        .then((data) => {
          resolve(data);
          // console.log('data', data);
          commit("setHasVisit", data.data.is_has);
          commit("setCheckInMsg", data.data.message);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  checkUserHasVisitToday({ commit }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      sitesService
        .checkUserHasVisitToday(payload)
        .then((data) => {
          resolve(data);
          commit(
            "setUserHasVisitTodayOnOneOfSites",
            data.data.userHasVisitToDayInOnOfSites
          );
          commit("setSgnedInUserVisitDetails", data.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          err.status != 401 && !err.data?.otp_error && err.data?.message && this._vm.$toast.error(err.data.message);
        });
    });
  },
  clearStausesForArea({ commit }) {
    commit("setStatusesForArea");
  },
};

export const mutations = {
  clearSitesWithAreasAndKiosksTreeList(state) {
    state.sitesWithAreasAndKiosks = [];
  },
  resetSitesState(state) {
    // Merge rather than replace so we don't lose observers
    Object.assign(state, getDefaultState());
  },
  setLong(state, payload) {
    state.long = payload;
  },
  setLat(state, payload) {
    state.lat = payload;
  },
  setRadius(state, payload) {
    state.radius = payload;
  },
  setLocationName(state, payload) {
    state.locationName = payload;
  },
  setZoom(state, payload) {
    state.zoom = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setHideSiteModal(state, payload) {
    state.hideSiteModal = payload;
  },
  setSites(state, payload) {
    state.sitesList = payload;
    // console.log(state.sitesList)
  },
  setSitesWithAreas(state, payload) {
    state.sitesWithAreas = payload;
  },
  setSitesWithAreasAndKiosks(state, payload) {
    state.sitesWithAreasAndKiosks = payload;
  },
  setAreas(state, payload) {
    state.siteAreas = payload;
  },
  setCountUsersSingnedIn(state, payload) {
    state.countUsersSingnedIn = payload;
  },
  setAreasFilter(state, payload) {
    state.areasFilter = payload;
  },
  setAreasMode(state, payload) {
    state.areasMode = payload;
  },
  setCompliances(state, payload) {
    state.areaCompliances = payload;
  },
  setDocuments(state, payload) {
    state.areaDocuments = payload;
  },
  setStausForAre(state, payload) {
    state.stausForAre = payload;
  },
  setAllStausesForArea(state, payload) {
    state.stausesForArea = payload;
  },
  actionState(state, update) {
    state.actionState = update;
  },
  setIsSignInOutMode(state, payload) {
    state.isSignInOutMode = payload;
  },

  setHasVisit(state, payload) {
    state.hasVisit = payload;
  },
  setCheckInMsg(state, payload) {
    state.checkInMsg = payload;
  },

  setLoader(state, payload) {
    state.isLoader = payload;
  },
  setStatusesForArea(state) {
    state.stausesForArea = [];
  },
  setUserHasVisitTodayOnOneOfSites(state, payload) {
    state.userHasVisitTodayOnOneOfSites = payload;
  },
  setSgnedInUserVisitDetails(state, payload) {
    state.signedInUserVisitDetails = payload;
  },
};

export const getters = {
  getLoading(state) {
    return state.loading;
  },
  getLong(state) {
    return state.long;
  },
  getLat(state) {
    return state.lat;
  },
  getRadius(state) {
    return state.radius;
  },
  getLocationName(state) {
    return state.locationName;
  },
  getZoom(state) {
    return state.zoom;
  },
  getHideSiteModal(state) {
    return state.hideSiteModal;
  },
  getSites(state) {
    return state.sitesList;
  },
  getNormalSites(state) {
    return state.sitesList;
  },
  getSitesWithAreas(state) {
    return state.sitesWithAreas;
  },
  getSitesWithAreasAndKiosks(state) {
    return state.sitesWithAreasAndKiosks;
  },
  getAreas(state) {
    return state.siteAreas;
  },
  getCountUsersSingnedIn(state) {
    return state.countUsersSingnedIn;
  },
  getAreasFilter(state) {
    return state.areasFilter;
  },
  getAreasMode(state) {
    return state.areasMode;
  },
  getCompliances(state) {
    return state.areaCompliances;
  },
  getAreaDocuments(state) {
    return state.areaDocuments;
  },
  getStatusForArea(state) {
    return state.stausForAre;
  },
  getStatusesForArea(state) {
    return state.stausesForArea;
  },
  actionState(state) {
    return state.actionState;
  },
  getIsSignInOutMode(state) {
    return state.isSignInOutMode;
  },
  getHasVisit(state) {
    return state.hasVisit;
  },
  getCheckInMsg(state) {
    return state.checkInMsg;
  },
  getLoader(state) {
    return state.isLoader;
  },
  getUserHasVisitTodayOnOneOfSites(state) {
    return state.userHasVisitTodayOnOneOfSites;
  },
  getSignedInUserVisitDetails(state) {
    return state.signedInUserVisitDetails;
  },
};
